export default __webpack_public_path__ + "static/media/like-outline.f4342ea1.svg";